<template>
    <page-view title="专家评价列表">
        <template slot="action">
        </template>
        <a-card>
            <a-form-model :model="form" ref="form">
                <a-row>
                    <a-col :span="5">
                        <a-form-model-item label="专家姓名" prop="projectName">
                            <a-input v-model="form.name"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="7" :offset="1">
                        <a-form-model-item label="专业类别" prop="groups">
                            <dict-cascader dictKey="expert_profession" v-model="form.groups" style="width: 100%"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="10" :offset="1">
                        <a-form-item label="专家出行日期">
                            <a-date-picker format="YYYY-MM-DD" v-model="form.startDate" placeholder="开始日期"/>
                            <span style="width: 6%;display: inline-block;text-align: center">至</span>
                            <a-date-picker format="YYYY-MM-DD" v-model="form.endDate" placeholder="结束日期"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24" class="footer-button">
                        <a-form-item :wrapperCol="{ span: 23 }" style="text-align: center">
                            <a-button type="primary" @click="onSearch">查询</a-button>
                            <a-button @click="reset" style="margin-left: 20px">重置</a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <s-table
                    ref="table"
                    :columns="columns"
                    :data="loadData"
                    :customRow="customRow"
                    :rowKey="record => record.expertId"
                    :pagination="{ showTotal: (total) => `共 ${total} 条` }"
            >
            </s-table>
        </a-card>
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import qs from 'qs'
import moment from 'moment'
import { getSortSql } from '@/utils/table'
import DictCascader from '@/components/dict/DictCascader'

const columns = [
  {
    title: '专家名称',
    dataIndex: 'expertName',
    width: 200
  },
  {
    title: '拟申报组别',
    align: 'center',
    dataIndex: 'groupsName'
  },
  {
    title: '参加次数',
    dataIndex: 'useNumber',
    sorter: true
  },
  {
    title: '优秀（次）',
    dataIndex: 'yx',
    sorter: true
  },
  {
    title: '合格（次）',
    dataIndex: 'hg',
    sorter: true
  },
  {
    title: '不合格（次）',
    dataIndex: 'bhg',
    sorter: true
  }
]
export default {
  name: 'expertFeedbackIndex',
  components: {
    PageView,
    STable,
    DictCascader
  },
  data () {
    return {
      columns,
      user: this.$ls.get('user'),
      caseTypeId: this.$route.query.caseTypeId,
      form: {
        startDate: moment().startOf('month'),
        endDate: moment().startOf('month').add(1, 'months')
      },
      total: null,
      customRow: (record, index) => {
        return {
          on: {
            click: () => {
              // this.onView(record.id)
              let data = {}
              data.expertId = record.expertId
              data.startDate = this.form.startDate
              data.endDate = this.form.endDate
              this.dateFormat(data)

              this.$router.push({
                path: '/selectExpertApply/expertFeesProjectList', query: data
              })
            }
          }
        }
      },
      sortMap: [
        { sortField: 'useNumber', sortFieldOrig: 'use_number', sortOrder: '' },
        { sortField: 'yx', sortFieldOrig: 'yx', sortOrder: '' },
        { sortField: 'hg', sortFieldOrig: 'hg', sortOrder: '' },
        { sortField: 'bhg', sortFieldOrig: 'bhg', sortOrder: '' }
      ],
      loadData: (parameter) => {
        const data = { ...this.form }
        data.sorting = getSortSql(parameter, this.sortMap)
        this.dateFormat(data)
        return this.$http.get('/api/1/expertmain/selectExpertFeedback/query_expertFeedback_list.json', {
          params: Object.assign(parameter, data)
        }).then(res => {
          if (res.page) {
            this.total = res.page.total
          }
          return res
        })
      }
    }
  },
  methods: {
    reset () {
      this.form = {
        startDate: moment().startOf('month'),
        endDate: moment().startOf('month').add(1, 'months')
      }
      this.refresh()
    },
    onSearch () {
      this.refresh()
    },
    refresh () {
      this.$refs.table.refresh()
    },
    onView (id) {
      this.$router.push({
        path: '/selectExpertApply/view?id=' + id
      })
    },
    dateFormat (data) {
      if (data.startDate) {
        data.startDate = data.startDate.format('YYYY-MM-DD')
      }
      if (data.endDate) {
        data.endDate = data.endDate.format('YYYY-MM-DD')
      }
      if (data.endDate < data.startDate) {
        this.$message.error('结束日期不能小于开始日期')
      }
    }
  }
}
</script>

<style lang="less" scoped>
    .ant-calendar-picker {
        width: 47% !important;
    }
</style>
